"use client";

import dynamic from "next/dynamic";
import { useEffect } from "react";

import HeroLanding from "@/components/salespage/sections/hero-landing";
const BentoGrid = dynamic(
  () => import("@/components/salespage/sections/bentogrid"),
);
const PortfolioFeature = dynamic(
  () => import("@/components/salespage/sections/portfolioFeature"),
);
const PricingSection = dynamic(
  () => import("@/components/salespage/sections/pricingsection"),
);
const Testimonials = dynamic(
  () => import("@/components/salespage/sections/testimonials"),
);
const TradingFeature = dynamic(
  () => import("@/components/salespage/sections/tradingFeature"),
);
import { getUserData } from "@/services/controllers/user";
import { useAppSelector } from "@/services/hooks/redux.hooks";

export default function IndexPage() {
  const { user_id } = useAppSelector((state) => state.user);
  useEffect(() => {
    const getAuthedUser = async () => await getUserData({});

    if (user_id) getAuthedUser();
  }, [user_id]);

  return (
    <>
      <HeroLanding />
      <PortfolioFeature />
      <BentoGrid />
      <TradingFeature />

      <PricingSection />
      <hr />
      <Testimonials />
    </>
  );
}
